import React, { ReactNode, type ComponentProps } from "react";
import { ContentCard as NdsContentCard } from "@narmi/design_system";

type NdsContentCardProps = ComponentProps<typeof NdsContentCard>;

// Re-exporting NDS ContentCardProps for external use
export type ContentCardProps = NdsContentCardProps;

/**
 * @deprecated Use `ContentCard` from `@narmi/design_system` instead.
 * This facade only makes it more challenging to upgrade NDS.
 */
const ContentCard = ({
  kind = "elevated",
  paddingSize = "l",
  onClick = () => {},
  isSelected = false,
  radiusSize,
  testId,
  children,
}: ComponentProps<typeof NdsContentCard>) => {
  return (
    <NdsContentCard
      kind={kind}
      paddingSize={paddingSize}
      onClick={onClick}
      isSelected={isSelected}
      testId={testId}
      radiusSize={radiusSize}
    >
      {children}
    </NdsContentCard>
  );
};

export default ContentCard;
